import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 16l3 -13l3 13l-6 0","key":"svg-0"}],["path",{"d":"M12 16v3c0 2.667 4 2.667 4 0","key":"svg-1"}]]

/**
 * IconUmbrellaClosed
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdW1icmVsbGEtY2xvc2VkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik05IDE2bDMgLTEzbDMgMTNsLTYgMCIgLz4KICA8cGF0aCBkPSJNMTIgMTZ2M2MwIDIuNjY3IDQgMi42NjcgNCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/umbrella-closed
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconUmbrellaClosed = createReactComponent('outline', 'umbrella-closed', 'UmbrellaClosed', __iconNode);

export default IconUmbrellaClosed;